import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { ExtraSearchParams, IEntitySearchParams, SearchParams } from '@mt-ng2/common-classes';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ISearchFilterCheckboxValueChangedEvent } from '@mt-ng2/search-filter-checkbox-control';
import { CarrierService } from '../services/carrier.service';
import { ClaimTypes } from '../../model/ClaimTypes';
import { ICarrier } from '../../model/interfaces/carrier';
import { Router } from '@angular/router';
import { CarriersEntityListConfig } from './carrier.entity-list-config';
import { IItemSelectedEvent, IColumnSortedEvent, SortDirection } from '@mt-ng2/entity-list-module';
import { entityListModuleConfig } from '../../common/shared.module';

@Component({
    selector: 'app-carrier',
    templateUrl: './carrier.component.html',
    standalone: false
})
export class CarrierComponent implements OnInit {
    searchControl = new UntypedFormControl();
    
    carriers: ICarrier[];
    total: number;
    currentPage = 1;
    query = '';
    entityListConfig = new CarriersEntityListConfig();
    order = this.entityListConfig.getDefaultSortProperty();
    orderDirection: string = this.entityListConfig.getDefaultSortDirection();
    includeArchived: boolean;
    
    canEdit: boolean;
    canAdd: boolean;

    constructor(
        private carrierService: CarrierService, 
        private notificationsService: NotificationsService, 
        private claimsService: ClaimsService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.canEdit = this.claimsService.hasClaim(ClaimTypes.Carriers, [ClaimValues.FullAccess]);
        this.canAdd = this.canEdit;
        this.includeArchived = false;
        this.getCarriers();
    }

    private buildSearch(): ExtraSearchParams[] {
        const _extraSearchParams: ExtraSearchParams[] = [];

        if (this.includeArchived) {
            _extraSearchParams.push(
                new ExtraSearchParams({
                    name: 'IncludeArchived',
                    value: 'true',
                }),
            );
        } else {
            _extraSearchParams.push(
                new ExtraSearchParams({
                    name: 'IncludeArchived',
                    value: 'false',
                }),
            );
        }

        return _extraSearchParams;
    }

    getCarriers(): void {
        const search = this.query;
        const _extraSearchParams: ExtraSearchParams[] = this.buildSearch();

        const searchEntity: IEntitySearchParams = {
            extraParams: _extraSearchParams,
            order: this.order,
            orderDirection: this.orderDirection,
            query: search && search.length > 0 ? search : '',
            skip: (this.currentPage - 1) * entityListModuleConfig.itemsPerPage,
            take: entityListModuleConfig.itemsPerPage,
        };

        const searchparams = new SearchParams(searchEntity);
        this.carrierService.get(searchparams).subscribe((answer) => {
            this.carriers = answer.body;
            this.total = +answer.headers.get('X-List-Count');
        });
    }

    includeSelectionChanged(event: ISearchFilterCheckboxValueChangedEvent): void {
        this.includeArchived = event.value;
        this.currentPage = 1;
        this.getCarriers();
    }

    search(query: string): void {
        this.query = query;
        this.currentPage = 1;
        this.getCarriers();
    }

    columnSorted(event: IColumnSortedEvent): void {
        this.order = event.column.sort.sortProperty;
        this.orderDirection = event.column.sort.direction === SortDirection.Desc ? 'desc' : 'asc';
        this.getCarriers();
    }

    carrierSelected(event: IItemSelectedEvent): void {
        void this.router.navigate(['/carriers', event.entity.Id]);
    }
}
